export const DEFAULT_PROMOTIONS_SORT_COLUMN = "promo_event_id";
export const DEFAULT_PROMOTIONS_SORT_ORDER = "descend" as const;

export const DEFAULT_PROMOTIONS_PRODUCT_SORT_COLUMN = "product_name";
export const DEFAULT_PROMOTIONS_PRODUCT_SORT_ORDER = "ascend" as const;
